// Use this when you implement translations
// import { useTranslation } from "react-i18next";
import { validationMessages } from "../utils/messages";
const useValidationMessage = () => {
    // const { t } = useTranslation('validation');

    /**
     * @param {string} field - field name like "email", "phone", etc.
     * @param {string} type - message type: "required", "invalid", etc.
     */
    // const getMessage = (field, type = "required") => {
    //     return t(`${field}.${type}`);
    // };
    const getMessage = (field, type = "required") => {
        return validationMessages[field] && validationMessages[field][type];
    };

    return { getMessage };
};

export default useValidationMessage;